import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

const defaultProgress = <CircularProgress />;

export default function(props: any) {
  const { loading, progressComponent } = props;

  if (loading) {
    return progressComponent || defaultProgress;
  } else {
    return props.children || <div />;
  }
}
